module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="input-group">\r\n    <input class="phx-chemin-input" type="text" value="" title="" />\r\n    <div class="input-group-append phx-cw-chemin-button">\r\n        <div class="input-group-text">\r\n            '+
((__t=(UTILS.getSVGIcon('hierarchie')))==null?'':__t)+
'\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class="phx-chemin-wrap">\r\n    <div class="phx-chemin-selection"></div>\r\n</div>';
}
return __p;
};
